module.exports = __webpack_public_path__ + "img/010_thumbnail.10217952.jpg";